import {
	GET_CASE_CHART_DETAILS,
	GET_CASE_CHART_DETAILS_SUCCESS,
	GET_CASE_CHART_DETAILS_FAIL,
	GET_CASE_CHART_DETAILS_RESET,
} from '../actions/getCaseChartDetailsAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const getCaseChartDetailsReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_CASE_CHART_DETAILS:
			return {
				...state,
				apiState: 'loading',
			};
		case GET_CASE_CHART_DETAILS_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case GET_CASE_CHART_DETAILS_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case GET_CASE_CHART_DETAILS_RESET:
			return initialState;
		default:
			return state;
	}
};

export default getCaseChartDetailsReducer;
